export default "__VITE_ASSET__B0afXYH7__"